module.exports = __webpack_public_path__ + "static/media/emoji_button.26c9e201.svg";